
export const initializedSelectedGlossary = (glossaryTypes) => {
  const initializedSelectedGlossaryState = {
    glossaryType: glossaryTypes.id,
    glossaryWords: glossaryTypes?.glossarywordSet?.edges,
    isRelatedWords: false
  }

  return initializedSelectedGlossaryState
}